module.exports = __webpack_public_path__ + "img/34.c67c393d.png";